"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var __1 = require("..");
var react_1 = require("@emotion/react");
var getCSSRules = function (_a) {
    var colors = _a.colors;
    return ({
        tabHead: {
            cursor: 'pointer',
            paddingBottom: 13,
            borderBottom: '3px solid transparent',
            margin: '0 12px',
            display: 'flex',
            flexShrink: 0,
            textTransform: 'uppercase',
            alignItems: 'center',
            transition: 'border-color ease .25s',
            color: colors.Grey[600],
        },
        active: {
            color: colors.Grey[900],
            borderBottomColor: colors.Hannibal[600],
        },
        badge: {
            color: colors.Grey[0],
            width: 28,
            height: 22,
            backgroundColor: colors.Grey[300],
            borderRadius: 50,
            display: 'flex',
            marginLeft: 8,
            alignItems: 'center',
            justifyContent: 'center',
        },
        activeBadge: {
            backgroundColor: colors.Hannibal[600],
        },
    });
};
var CountBadge = function (_a) {
    var value = _a.value, active = _a.active;
    var theme = (0, react_1.useTheme)();
    var styles = getCSSRules(theme);
    return ((0, jsx_runtime_1.jsx)("div", __assign({ css: (0, react_1.css)(styles.badge, active && styles.activeBadge) }, { children: (0, jsx_runtime_1.jsx)(__1.Typography, __assign({ variant: "textSmall" }, { children: value }), void 0) }), void 0));
};
var TabHead = function (_a) {
    var label = _a.label, onClick = _a.onClick, active = _a.active, badge = _a.badge, className = _a.className;
    var theme = (0, react_1.useTheme)();
    var styles = getCSSRules(theme);
    return ((0, jsx_runtime_1.jsx)(react_1.ClassNames, { children: function (_a) {
            var _b;
            var css = _a.css, cx = _a.cx;
            return ((0, jsx_runtime_1.jsxs)("div", __assign({ onClick: onClick, className: cx(css(styles.tabHead), (_b = {},
                    _b[css(styles.active)] = active,
                    _b), className) }, { children: [(0, jsx_runtime_1.jsx)(__1.Typography, __assign({ weight: "bold", variant: "textSmall" }, { children: label }), void 0), badge !== undefined && (0, jsx_runtime_1.jsx)(CountBadge, { active: active, value: badge }, void 0)] }), void 0));
        } }, void 0));
};
exports.default = TabHead;
//# sourceMappingURL=TabHead.js.map